<script>
  import { createEventDispatcher } from 'svelte';
  import Button from '@components/Button.svelte';
  import CreatorSpotlightAjax from '@ajax/creator_spotlight';
  import Fuse from 'fuse.js';

  const dispatch = createEventDispatcher();

  export let mobile = false;
  export let maxSelected = 4;
  let availableBrands = [];
  $: filteredBrands = availableBrands;
  let selectedBrands = [];
  let searchTerm = '';
  let warn = false;

  let loadAllCreatorSpotlightBrands = async function () {
    let res = await CreatorSpotlightAjax.getAllSpotlightBrands();
    availableBrands = res.brands;
  };

  let loadUserCreatorSpotlightBrands = async function () {
    let res = await CreatorSpotlightAjax.getSpotlightBrands();
    selectedBrands = [...res.brands];
  };

  let setCreatorSpotlightBrand = async function (val) {
    let res = await CreatorSpotlightAjax.createSpotlightBrand({ id: val });
    return res;
  };

  let removeCreatorSpotlightBrand = async function (val) {
    let res = await CreatorSpotlightAjax.deleteSpotlightBrand(val);
    warn = false;
    return res;
  };

  const toggleBrandsSelect = function (currentValue) {
    if (selectedBrands.some((i) => i.id === currentValue.id)) {
      selectedBrands = selectedBrands.filter(function (brand) {
        return brand.id != currentValue.id;
      });
      removeCreatorSpotlightBrand(currentValue.id);
    } else {
      if (selectedBrands.length < maxSelected) {
        selectedBrands = [...selectedBrands, currentValue];
        setCreatorSpotlightBrand(currentValue.id);
      } else {
        warn = true;
      }
    }
  };

  const searchBrands = function () {
    let fuse = new Fuse(availableBrands, {
      keys: ['value'],
      threshold: 0.25,
    });

    if (!searchTerm) {
      filteredBrands = availableBrands;
    } else {
      filteredBrands = fuse.search(searchTerm).map((x) => {
        return x.item;
      });
    }
  };

  $: isSelected = (id) => {
    return selectedBrands.some((i) => i.id === id);
  };
  $: selectedSpotsRemaining = maxSelected - selectedBrands.length;

  loadUserCreatorSpotlightBrands();
  loadAllCreatorSpotlightBrands();
</script>

<style style="text/scss" lang="scss">
  .creator-spotlight-brands {
    .ui-header {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      gap: 16px;
    }
    .ui-title {
      font-weight: 500;
      font-size: 18px;
      line-height: 22px;
      max-width: 350px;
    }
    .ui-subtitle {
      margin-bottom: 16px;
      color: #717171;

      &.warn {
        color: #ff5567;
      }
    }
    .ui-back,
    .ui-close {
      background-color: transparent;
      border: none;
      margin: 0;
      padding: 0;
      opacity: 0.5;

      &:hover {
        opacity: 1;
      }
    }

    .select-container {
      display: inline-flex;
      gap: 12px;
      flex-wrap: wrap;
    }

    .ui-select-label {
      border: 1px solid #e3e3e3;
      color: #717171;
      padding: 8px 16px;
      border-radius: 32px;
      font-weight: 500;
      cursor: pointer;
      transition: 200ms;

      @media (hover: hover) {
        &:hover {
          background-color: #f5f5f5;
        }
      }

      &.selected {
        border-color: #717171;
        background-color: #f1f1f1;
        color: #1c1c1c;
      }

      &.disabled {
        cursor: default;
        background: none;
      }
    }

    .ui-search-container {
      background: #f1f1f1;
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 2px 12px;
      border-radius: 12px;
      margin-bottom: 32px;
      input {
        background: #f1f1f1;
        margin-bottom: 0;
        border-color: transparent;
        flex: auto;
        outline: none;
      }
    }

    .ui-select-label__empty {
      border: 1px dashed #c6c6c6;
      height: 40.5px;
      width: 100px;
      padding: 0;
      cursor: default;
      color: rgba(0, 0, 0, 0);
    }

    .selected-section,
    .suggested-section {
      text-align: left;
      margin-bottom: 32px;

      .ui-subtitle {
        margin-bottom: 8px;
      }
    }

    .suggested-section {
      margin-bottom: 24px;
      .select-container {
        justify-content: center;
        max-height: 41dvh;
        overflow-y: auto;
        /* Hide scrollbar for IE, Edge and Firefox */
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
      }

      /* Hide scrollbar for Chrome, Safari and Opera */
      .select-container::-webkit-scrollbar {
        display: none;
      }
    }
  }
</style>

<div class="creator-spotlight-brands" class:mobile={mobile}>
  <div class="ui-header">
    <button
      class="ui-back"
      on:click={() => {
        dispatch('back');
      }}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.85501 7.26609L10.5901 1.49831L11.6538 2.55596L5.91867 8.32373C5.82171 8.42125 5.82171 8.57877 5.91867 8.67628L11.6538 14.4441L10.5901 15.5017L4.85501 9.73393C4.17626 9.05132 4.17626 7.94869 4.85501 7.26609Z"
          fill="#1C1C1C" />
      </svg>
    </button>
    <div class="ui-title">Favorite Brands</div>
    <button
      class="ui-close"
      on:click={() => {
        dispatch('close');
      }}
      ><svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M6.93932 8.50003L2.00049 13.4386L3.06112 14.4993L8 9.56066L12.9389 14.4993L13.9995 13.4386L9.06069 8.50003L13.9995 3.56142L12.9389 2.50073L8 7.43939L3.06112 2.50073L2.00049 3.56142L6.93932 8.50003Z"
          fill="#1C1C1C" />
      </svg>
    </button>
  </div>
  <p class="ui-subtitle" class:warn={warn}>Select up to 4</p>
  <div class="ui-search-container">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M13.1567 7.32783C13.1567 10.5467 10.5473 13.1561 7.32837 13.1561C4.10944 13.1561 1.5 10.5467 1.5 7.32783C1.5 4.10895 4.10944 1.49951 7.32837 1.49951C10.5473 1.49951 13.1567 4.10895 13.1567 7.32783ZM11.953 13.013C10.6916 14.0403 9.08192 14.6561 7.32837 14.6561C3.28102 14.6561 0 11.3751 0 7.32783C0 3.28051 3.28102 -0.000488281 7.32837 -0.000488281C11.3757 -0.000488281 14.6567 3.28051 14.6567 7.32783C14.6567 9.08135 14.0409 10.691 13.0136 11.9523L16.0013 14.94L14.9406 16.0007L11.953 13.013Z"
        fill="#B3B3B3" />
    </svg>
    <input
      class="ui-search-input"
      type="text"
      placeholder="Search brands"
      bind:value={searchTerm}
      on:keyup={searchBrands} />
  </div>

  <div class="selected-section">
    <div class="ui-subtitle">My Brands</div>
    <div class="select-container">
      {#each selectedBrands as brand}
        <div class="select-item">
          <div class="ui-select-label" class:selected={true} on:click={() => toggleBrandsSelect(brand)}>
            {brand.value}
          </div>
        </div>
      {/each}
      {#each Array(selectedSpotsRemaining) as _}
        <div class="select-item">
          <div class="ui-select-label ui-select-label__empty">_</div>
        </div>
      {/each}
    </div>
  </div>
  <div class="suggested-section">
    <div class="ui-subtitle">Suggested</div>
    <div class="select-container">
      {#each filteredBrands as brand}
        <div class="select-item">
          <div
            class="ui-select-label"
            class:disabled={selectedBrands.length === maxSelected && !isSelected(brand.id)}
            class:selected={isSelected(brand.id)}
            on:click={() => toggleBrandsSelect(brand)}>
            {brand.value}
          </div>
        </div>
      {/each}
    </div>
  </div>
  <div class="finished-btn">
    <Button
      disabled={selectedBrands.length < 2}
      colorScheme="black"
      style="padding-left: 40px; padding-right: 40px; width: auto; margin: 0;"
      text={selectedBrands.length < 2 ? 'Select at least 2' : 'Continue'}
      on:click={() => {
        dispatch('finished');
      }} />
  </div>
</div>
